import { render, staticRenderFns } from "./MealRecipes.vue?vue&type=template&id=a5796d18&scoped=true&"
import script from "./MealRecipes.vue?vue&type=script&lang=js&"
export * from "./MealRecipes.vue?vue&type=script&lang=js&"
import style0 from "./MealRecipes.vue?vue&type=style&index=0&id=a5796d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5796d18",
  null
  
)

component.options.__file = "MealRecipes.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VResponsive } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VContainer,
  VFlex,
  VImg,
  VLayout,
  VResponsive,
})
